import type {
  FinalizeKeyRotationPayload,
  UploadRotatedFileKeysPayload,
  UserFileKeyRef,
} from '@/types/fileKey/FileKeyRegeneration';

/**
 * Backend seam for the change-password file-key rotation (cqrs SDB-726/733/734).
 */
export abstract class FileKeyRegenerationService {
  /** Lists every file key the current user holds ({ fileId, fileKey }). */
  abstract getUserFileKeys(): Promise<UserFileKeyRef[]>;

  /**
   * Hands the regenerated-keys tar CID to HAP, which fetches and untars it.
   * Byte transfer only — nothing is committed by this call.
   */
  abstract uploadRotatedFileKeys(payload: UploadRotatedFileKeysPayload): Promise<void>;

  /**
   * Commits the rotation: OPAQUE record + fileId→CID mapping + new ML-KEM keys
   * in one Fabric-backed command. The only call in the flow that mutates CQRS.
   */
  abstract finalizeKeyRotation(payload: FinalizeKeyRotationPayload): Promise<void>;
}
